import { I18nPluralPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { HighlightSection } from '@modules/content-api/adapter/highlight.adapter';

import { ImageComponent } from '../../media/image/image.component';
import { SectionHeadlineComponent } from '../section-headline/section-headline.component';

@Component({
  selector: 'mb-highlight-section',
  templateUrl: './highlight-section.component.html',
  styleUrls: ['./highlight-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SectionHeadlineComponent, ImageComponent, RouterLink, I18nPluralPipe, TranslatePipe],
})
export class HighlightSectionComponent {
  @Input() highlightSection!: HighlightSection;
}
